import { LogoAdelante } from '@/components/layout';
import { Button } from '@/components/ui/button';
import { Toaster } from '@/components/ui/sonner';
import { modoDev, msalInstance, scopesLogin } from '@/lib/auth';
import { esSesionFiori, esSesionLab } from '@/lib/cliente';
import { router } from '@/router/routes';
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { KeyRound } from 'lucide-react';
import { RouterProvider } from 'react-router-dom';

function BotonLogin() {
  const { instance } = useMsal();
  return (
    <Button size="lg" onClick={() => instance.loginRedirect({ scopes: scopesLogin })}>
      Iniciar sesión con Microsoft
    </Button>
  );
}

function BotonLabPin() {
  return (
    <Button
      size="lg"
      variant="outline"
      onClick={() => {
        window.location.href = '/lab-login';
      }}
      className="gap-1.5"
    >
      <KeyRound className="h-4 w-4" />
      Soy laboratorista (entrar con PIN)
    </Button>
  );
}

function BotonFioriPin() {
  return (
    <Button
      size="lg"
      variant="outline"
      onClick={() => {
        window.location.href = '/fiori-login';
      }}
      className="gap-1.5"
    >
      <KeyRound className="h-4 w-4" />
      Soy operador Fiori (entrar con PIN)
    </Button>
  );
}

function PantallaLogin() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4">
      <div className="flex flex-col items-center gap-6 text-center">
        <LogoAdelante altura={40} />
        <div className="space-y-1">
          <h1 className="text-2xl font-bold tracking-wider">ADELANTE.</h1>
          <p className="text-sm text-muted-foreground">
            Iniciá sesión con tu cuenta corporativa para continuar.
          </p>
        </div>
        <div className="flex flex-col items-stretch gap-2">
          <BotonLogin />
          <BotonLabPin />
          <BotonFioriPin />
        </div>
      </div>
    </div>
  );
}

/**
 * Si la ruta actual es /lab-login o /fiori-login NO tiene sentido mostrar
 * la pantalla de login MSAL detrás — el usuario quiere entrar con PIN.
 * Renderizamos directo el router (que sirve la pantalla de PIN correspondiente).
 */
function rutaEsLabLogin(): boolean {
  return (
    window.location.pathname.startsWith('/lab-login') ||
    window.location.pathname.startsWith('/fiori-login')
  );
}

export function App() {
  // Modo dev: bypass MSAL completamente.
  if (modoDev) {
    return (
      <>
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
        <Toaster />
      </>
    );
  }

  if (!msalInstance) {
    throw new Error('msalInstance es null fuera de modo dev — revisar lib/auth.ts');
  }

  // Sesión lab o fiori activa (JWT propio en localStorage): bypaseamos
  // MSAL y renderizamos el router. cliente.ts usa ese token en las llamadas.
  if (esSesionLab() || esSesionFiori()) {
    return (
      <MsalProvider instance={msalInstance}>
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
        <Toaster />
      </MsalProvider>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
        <Toaster />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        {/* /lab-login es accesible sin login Entra → renderizamos el router
            que sirve la pantalla del teclado. El resto cae a PantallaLogin. */}
        {rutaEsLabLogin() ? (
          <>
            <RouterProvider router={router} future={{ v7_startTransition: true }} />
            <Toaster />
          </>
        ) : (
          <PantallaLogin />
        )}
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}
